<template>
  <div class="insights_secondary">
    <div class="insightCards">
      <div class="topRowCards">
        <div class="xsCard xsLong">
          <div class="card__titleRow">
            <div class="card__titleRow__name">Viewership</div>
            <div class="card__titleRow__button">
              <div class="card__titleRow__button__text">Networks</div>
            </div>
          </div>
          <div class="viewershipGraphContainer">
            <div class="viewershipGraphContainer__graph">
              <div class="viewershipGraphContainer__graph__headers">
                <div class="viewershipGraphContainer__graph__headers__index"> &nbsp;</div>
                <div class="viewershipGraphContainer__graph__headers__headerItem">Network</div>
                <div class="viewershipGraphContainer__graph__headers__headerItem">Comp</div>
                <div class="viewershipGraphContainer__graph__headers__headerItem">Reach</div>
                <div class="viewershipGraphContainer__graph__headers__headerItem">Index</div>
              </div>
              <div class="viewershipGraphContainer__graph__rows">
                <div class="viewershipGraphContainer__graph__rows__rowDetail" v-for="(v, index) in secondaryInsightViewershipMockData.viewership.slice(0, 5)" :key="v.id">
                  <div class="viewershipGraphContainer__graph__rows__rowDetail__index">{{ index + 1 }}</div>
                  <div class="viewershipGraphContainer__graph__rows__rowDetail__rowItem blue">{{ v.network }}</div>
                  <div class="viewershipGraphContainer__graph__rows__rowDetail__rowItem">{{ v.comp }}</div>
                  <div class="viewershipGraphContainer__graph__rows__rowDetail__rowItem">{{ v.reach }}</div>
                  <div class="viewershipGraphContainer__graph__rows__rowDetail__rowItem">{{ v.indexVal }}</div>
                </div>
              </div>

            </div>
            <div class="viewershipGraphContainer__graph__right">
              <div class="viewershipGraphContainer__graph__right__headers">
                <div class="viewershipGraphContainer__graph__right__headers__index"> &nbsp;</div>
                <div class="viewershipGraphContainer__graph__right__headers__headerItem">Network</div>
                <div class="viewershipGraphContainer__graph__right__headers__headerItem">Comp</div>
                <div class="viewershipGraphContainer__graph__right__headers__headerItem">Reach</div>
                <div class="viewershipGraphContainer__graph__right__headers__headerItem">Index</div>
              </div>
              <div class="viewershipGraphContainer__graph__right__rows">
                <div class="viewershipGraphContainer__graph__right__rows__rowDetail" v-for="(v, index) in secondaryInsightViewershipMockData.viewership.slice(5)" :key="v.id">
                  <div class="viewershipGraphContainer__graph__right__rows__rowDetail__index">{{ index + 1 }}</div>
                  <div class="viewershipGraphContainer__graph__right__rows__rowDetail__rowItem blue">{{ v.network }}</div>
                  <div class="viewershipGraphContainer__graph__right__rows__rowDetail__rowItem">{{ v.comp }}</div>
                  <div class="viewershipGraphContainer__graph__right__rows__rowDetail__rowItem">{{ v.reach }}</div>
                  <div class="viewershipGraphContainer__graph__right__rows__rowDetail__rowItem">{{ v.indexVal }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="bottomRowCards">
        <div class="xsCard xsShort">
          <div class="card__title">Digital Affinities</div>
          <div class="digitalAffinities">
            <div class="digitalAffinities__headers">
              <div class="headerItem">Property</div>
              <div class="headerItem">Uniques/Month</div>
            </div>
            <div class="digitalAffinities__rows">
              <div class="digitalAffinities__rows__rowDetail" v-for="da in secondaryInsightViewershipMockData.digitalAffinities" :key="da.property">
                <div class="rowItem">{{ da.property }}</div>
                <div class="rowItem">{{ formattedCount(da.monthlyUnique) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="xsCard xsShort">
          <div class="card__title">OTS Segment Affinities</div>
          <div class="otsSegmentAffinities">
            <div class="otsSegmentAffinities__row" v-for="sa in secondaryInsightViewershipMockData.segmentAffinities" :key="sa.segment">
              <div class="otsSegmentAffinities__row__value">{{ sa.value }} &nbsp;-&nbsp;</div>
              <div class="otsSegmentAffinities__row__segmentName">{{ sa.segment }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { smallNumber } from '@/helpers'

export default {
  props: {
  },
  data () {
    return {
      secondaryInsightViewershipMockData: {
        segmentAffinities: [
          {
            segment: 'Luxury Traveler',
            value: '1.5x'
          },
          {
            segment: 'Millenial',
            value: '2.5x'
          },
          {
            segment: 'Insurance Seeker',
            value: '3.2x'
          },
          {
            segment: 'Sports Fan',
            value: '4.7x'
          },
          {
            segment: 'C-Suite',
            value: '4.7x'
          }
        ],
        digitalAffinities: [
          {
            property: 'TNT',
            monthlyUnique: 17500000
          },
          {
            property: 'NCAA',
            monthlyUnique: 17000000
          },
          {
            property: 'ADULT SWIM',
            monthlyUnique: 16.700000
          },
          {
            property: 'PGA',
            monthlyUnique: 15900000
          },
          {
            property: 'BLEACHER REPORT',
            monthlyUnique: 15000000
          },
          {
            property: 'TCM',
            monthlyUnique: 12200000
          },
          {
            property: 'NBA',
            monthlyUnique: 9000000
          },
          {
            property: 'TBS',
            monthlyUnique: 5500000
          },
          {
            property: 'FILMSTRUCK',
            monthlyUnique: 2300000
          },
          {
            property: 'TRUE TV',
            monthlyUnique: 907000
          }
        ],
        viewership: [
          {
            id: 1,
            network: 'CNN',
            comp: '63%',
            reach: '22M',
            indexVal: '109'
          },
          {
            id: 2,
            network: 'TBS',
            comp: '16%',
            reach: '60M',
            indexVal: '103'
          },
          {
            id: 3,
            network: 'TNT',
            comp: '38%',
            reach: '83M',
            indexVal: '103'
          },
          {
            id: 4,
            network: 'TOON',
            comp: '45%',
            reach: '3M',
            indexVal: '99'
          },
          {
            id: 5,
            network: 'TRU TV',
            comp: '32%',
            reach: '23.4M',
            indexVal: '112'
          },
          {
            id: 6,
            network: 'BOOM',
            comp: '5%',
            reach: '5M',
            indexVal: '91'
          },
          {
            id: 7,
            network: 'HLN',
            comp: '20%',
            reach: '21M',
            indexVal: '102'
          },
          {
            id: 8,
            network: 'AS',
            comp: '50%',
            reach: '100M',
            indexVal: '155'
          },
          {
            id: 9,
            network: 'TCM',
            comp: '34%',
            reach: '13.8M',
            indexVal: '91'
          },
          {
            id: 10,
            network: 'GSN',
            comp: '32%',
            reach: '23.4M',
            indexVal: '112'
          }
        ]
      }
    }
  },
  methods: {
    formattedCount (count) {
      if (!count) {
        return 'N/A'
      }
      const formattedCount = smallNumber(count, 1)
      return formattedCount
    }
  }
}
</script>

<style lang="scss">
  $slateGray: #435261;
  $lightGray: #F3F3F3;
  $blue: #0052E6;
  $white: #FFFFFF;

  .insights_secondary {
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .insightCards {
    display: flex;
    flex-flow: column;
    justify-content: center;
    justify-items: center;
    padding: 1.5em;
  }
  .topRowCards, .bottomRowCards {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }
  .bottomRowCards {
    margin-top: 1em;
  }
  .xsCard {
    background-color: $white;
    padding: 1em 3em;
    display: flex;
    flex-flow: column;
    align-items: center;
    &.xsShort {
      height: 21em;
      width: 23em;
      margin-right: 2em;
    }
    &.xsLong {
      height: 20em;
      width: 54em;
    }
  }
  .card__titleRow {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    &__name {
      display: flex;
      width: 38%;
    }
    &__button {
      background-color: $slateGray;
      height: 2.5em;
      width: 9em;
      color: $white;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .viewershipGraphContainer {
    display: flex;
    flex-flow: row;
    width: 100%;
    justify-content: space-between;
    margin-top: 1.5em;
    &__graph {
      display: flex;
      flex-flow: column;
      width: 47%;
      &__headers {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        font-size: 0.85em;
        padding: 0 1em;
        &__index {
          width: 2.25em;
        }
        &__headerItem {
          flex: 1;
        }
      }
      &__rows {
        display: flex;
        flex-flow: column;
        &__rowDetail {
          display: flex;
          flex-flow: row;
          justify-content: space-between;
          font-weight: bold;
          color: $slateGray;
          padding: 0.75em;
          &__index {
            width: 2.25em;
          }
          &__rowItem {
            flex: 1;
          }
          &:nth-child(even) {
            background-color: $lightGray;
          }
        }
      }
    }
    .viewershipGraphContainer__graph__rows__rowDetail__rowItem.blue {
      color: $blue !important;
    }
    .viewershipGraphContainer__graph__right__rows__rowDetail__rowItem.blue {
      color: $blue !important;
    }
    &__graph__right {
      display: flex;
      flex-flow: column;
      width: 47%;
      &__headers {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        font-size: 0.85em;
        padding: 0 1em;
        &__index {
          width: 2.25em;
        }
        &__headerItem {
          flex: 1;
        }
      }
      &__rows {
        display: flex;
        flex-flow: column;
        &__rowDetail {
          display: flex;
          flex-flow: row;
          justify-content: space-between;
          font-weight: bold;
          color: $slateGray;
          padding: 0.75em;
          &__index {
            width: 2.25em;
          }
          &__rowItem {
            flex: 1;
          }

          &:nth-child(odd) {
            background-color: $lightGray;
          }
        }
      }
    }
  }

  .digitalAffinities {
    display: flex;
    flex-flow: column;
    width: 110%;
    padding: 0.5em;
    &__headers {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      font-size: 0.85em;
      padding: 0 10px;
    }
    &__rows {
      display: flex;
      flex-flow: column;
      &__rowDetail {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        font-weight: bold;
        padding: 3px 11px;
        color: $slateGray;
        &:nth-child(even) {
          background-color: $lightGray;
        }
      }
    }
  }

  .otsSegmentAffinities {
    display: flex;
    flex-flow: column;
    padding-top: 1em;
    &__row {
      display: flex;
      flex-flow: row nowrap;
      font-size: 1.5em;
      padding: 0.5em 0px;
      font-weight: 200;
      &__segmentName {
        color: $blue;
        letter-spacing: 4px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// secondary.vue?fecbd986